import Nixi1Spinner from 'components/Nixi1Spinner'
import React from 'react'
import './styles.scss'

/**
 *
 * @param {string} props.type primary, secondary
 * @returns
 */
const Index = (props) => {
  const { type = 'primary', onClick, icon, isSubmitting, value, className, size } = props
  return (
    <div className={`tag-button button-${type} ${icon ? 'icon-style' : ''} ${className ? className : ''} ${size}`}
      onClick={()=> {
        if (!isSubmitting && type !== 'disabled') onClick()
        else return false
      }}
    >
      {icon && icon}
      {isSubmitting ? (
        <Nixi1Spinner width='15px' height='15px' />
      ) : (
        <p className='text-ellipsis'>{value}</p>
      )}
    </div>
  )
}

export default Index
